import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['choice', 'politicalExpositionFields'];

  connect() {
    this.toggleChoice();
  }

  toggleChoice() {
    if (this.choiceTarget.checked) {
      this.politicalExpositionFieldsTargets.forEach((elem) => {
        elem.classList.remove('d-none');
      });
    } else {
      this.politicalExpositionFieldsTargets.forEach((elem) => {
        elem.classList.add('d-none');
        elem.querySelector('input').value = '';
      });
    }
  }
}
